<template>
  <router-link to="/" class="logo">
    <img src="@/assets/img/logo.svg" alt="" />
  </router-link>
</template>
<script>
export default {
  name: "Logo",
};
</script>